import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType"
import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes"
import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType"

const initState = {
    groupProject: ''
}

export const groupProjectData = {
    name: "Group Project Form",
    initialState: initState,
    section: [
        {
            sectionId: 'groupProject',
            title: "Group Project Form",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-6 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "groupProject",
                    label: "Project Name",
                    Field_Name: "Project",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "groupProject",
                    isMultiSelect: true,
                    fieldSetting: {
                        placeholder: "Please Select Project",
                        allowSpace: true,
                        options: [],
                        isLoading: false,
                        isMultiSelect: true
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-6 validation-text-model",
                    },
                }
            ]
        }
    ]
}

export const GroupProjectGridConfig = {
    columns: [
        {
            name: "Project Name",
            fieldName: "projectName",
            allowShort: false,
            colStyle: {
                width: "80%",
                textAlign: "center",
              }, 
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            colStyle: {
                width: "20%",
                textAlign: "center",
              },
            defaultAction: {
                allowDelete: true,
            },
        },
    ],
}